import { TagManager } from '@mineko/react-gtm-promisified';

export const GtmInit = TagManager.init;
